import { List, ListItem, ListItemText, Typography } from "@mui/material";

import { ExpandedEcrAssignmentRow } from "api/memberPortal/reports/expandedEcrAssignment/expandedEcrAssignment.types";

const ProjectTeamCell = ({
  row: { project_team },
}: {
  row: ExpandedEcrAssignmentRow;
}) => {
  return (
    <List sx={{ padding: "0" }}>
      {project_team.map(({ user_id, product_id, role }) => {
        const {
          first_name,
          last_name = "",
          non_user_member: nonUser,
        } = user_id;

        const userDisplay = nonUser ?? `${first_name} ${last_name}`.trim();
        const roleDisplay = role ? `(${role})` : "";

        return (
          <ListItem key={`${user_id.user_id} - ${product_id}`}>
            <ListItemText
              sx={{ margin: 0 }}
              primary={<Typography variant="inherit">{userDisplay}</Typography>}
              secondary={
                <Typography variant="caption">{roleDisplay}</Typography>
              }
            />
          </ListItem>
        );
      })}
    </List>
  );
};

export default ProjectTeamCell;
